import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';
import { LoginPage } from './features/login/login-page';
import { LandingPage } from './landing/landing-page';
import { Shell } from './layout/shell/shell';

export const routes: Routes = [
  { path: '', component: LandingPage },
  { path: 'login', component: LoginPage },
  { path: 'chat', component: Shell, canActivate: [authGuard], title: 'TAI' },
  { path: 'chat/:id', component: Shell, canActivate: [authGuard], title: 'TAI' },
  { path: '**', redirectTo: '' },
];
